module.exports = __webpack_public_path__ + "img/swiper2.acf08b8a.png";